import { Routes } from '@angular/router';
import { HomepageComponent } from './components/homepage/homepage.component';
import { BuilderComponent } from './components/builder/builder.component';
import { GuidMissingErrorComponent } from './components/error/guid-missing-error/guid-missing-error.component';
import { FormBuilderV2Component } from './components/v2/form-builder/form-builder.component';

export const routes: Routes = [
  { 
    path: '', 
    component: HomepageComponent 
  },
  { 
    path: 'builder', 
    component: BuilderComponent 
  },
  { 
    path: 'form-builder-v2', 
    component: FormBuilderV2Component 
  },
  {
    path: 'error/guid-missing',
    component: GuidMissingErrorComponent
  },
  { 
    path: '**', 
    redirectTo: '/error/guid-missing' 
  }
];
